module.exports = __webpack_public_path__ + "static/media/loadingx43px.35443cb7.svg";